import { render, staticRenderFns } from "./InterfaceVariable.vue?vue&type=template&id=2dc337de&scoped=true"
import script from "./InterfaceVariable.vue?vue&type=script&lang=js"
export * from "./InterfaceVariable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc337de",
  null
  
)

export default component.exports